<template>
  <div class="container" v-if="src">
    <div class="mt-1" v-if="!hideDownload">
      <span class="font-weight-bold">
        Download Form
        <v-icon color="black">mdi-arrow-down</v-icon>
      </span>
      <FileComponent
        class="py-2"
        :file="document"
        customActions
        disabled
        disablePreview
        downloadDirectly
      />
    </div>
    <div class="mb-1" v-for="page in pageCount" :key="page" :style="style">
      <pdf :page="page" :src="src" />
    </div>
  </div>
</template>
<script>
import { getFilePreviewSettings } from "@/utils/files";
import pdf from "vue-pdf";
import FileComponent from "@/components/common/FileComponent";

export default {
  props: {
    document: {
      type: Object,
      required: true
    },
    hideDownload: Boolean
  },
  components: { pdf, FileComponent },
  async created() {
    const { src } = await getFilePreviewSettings(this.document);
    this.src = src;
    const loadingTask = pdf.createLoadingTask(this.src);
    const { numPages } = await loadingTask.promise;
    this.pageCount = numPages;
  },
  data() {
    return {
      style: { border: "1px solid #8c878770" },
      src: null,
      pageCount: 0
    };
  }
};
</script>

<style lang="scss"></style>
